import * as React from 'react';

import ResearchNav from './nav';
import wechatAuth from './wechatAuth';

import config from '@/server/config';
import request from '@/server/request';

export default class ResearchAnalysis extends React.Component {
    public state = {
        labels: [], // 标签
        labelIndex: 0, // 标签索引
        loadOver: false, // 是否加载全部
        list: [], // 列表
    };

    private page: number = 1;
    private pageSize: number = 10;
    private isLoading: boolean = false; // 是否加载中
    private loadTimer: any;

    public componentDidMount() {

        this.getLabels();
        wechatAuth();
        window.addEventListener('scroll', this.scrollAction.bind(this));

    }

    public componentWillUnmount() { 
        window.removeEventListener('scroll', this.scrollAction.bind(this));
    }

    public render() {
        const state = this.state;
        return (
            <section>
                <ResearchNav index={1} />
                <div className="zsfw">
                    {/* <button className="bjbtn"><Link to="/research/analysis-edit">编辑订阅产品</Link></button> */}
                    <ul className="zsfwnav">
                        {
                            state.labels.map((v: any, k: number) => { 
                                return (
                                    <li className={state.labelIndex === k ? 'current' : ''} key={v.labelTypeId} onClick={ () => this.selectLabel(k) }>{ v.labelTypeName }</li>
                                )
                            })
                        }
                        
                    </ul>

                    <div className="jxlist">
                        <ul>
                            {
                                state.list.map((v: any, k: number) => { 
                                    return (
                                        <li key={v.id}>
                                            <h2>
                                                <a href={ v.mobileUrl } className="zxlist">
                                                    【{v.labelType}】{v.articleName}
                                                </a>
                                            </h2>
                                            <div className="date">
                                                <em>{v.releaseTimeStr}</em>
                                            </div>
                                            <div className="label">
                                                {
                                                    v.labelList && v.labelList.map((labelItem: any) => { 
                                                        return (
                                                            <i key={ labelItem.id }>
                                                                <a href={ labelItem.mobileLabelUrl }>{ labelItem.lbelName }</a>
                                                            </i>
                                                        )
                                                    })
                                                }
                                                
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul> 
                    </div>
                </div>
            </section>
        )
    }

    // 获取分类
    private async getLabels() {
        const r = await request({
            url: `${config.API}news/wap/subscribe/labelType/navs`,
        });

        if (r.code === 1) {
            this.setState({
                labels: r.obj || []
            }, () => { 
                    this.getList();
            });
        }
    }

    // 获取列表数据
    private async getList() { 
        const r = await request({
            url: `${config.API}news/wap/subscribe/queryArticlePage?labelTypeId=${this.state.labels[this.state.labelIndex]['labelTypeId']}&pageNum=${this.page}&pageSize=${this.pageSize}`
        });
        
        this.isLoading = false;
        if (r.code === 1) { 
            this.setState({
                list: this.state.list.concat(r.obj.list || []),
                loadOver: r.obj.pageNum >= r.obj.pages
            });
        }
    }

    // 滚动加载
    private scrollAction() { 
        if (this.isLoading || this.state.loadOver) {
            return;
        }

        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {

            if (this.loadTimer) {
                clearTimeout(this.loadTimer);
            }

            this.loadTimer = setTimeout(() => {
                this.loadMore();
            }, 500);

        }
    }

    // 加载更多文章内容
    private loadMore() {
        this.page++;
        this.isLoading = true;
        this.getList();
    }

    /**
     * 选择标签
     * @param index {number}
     */
    private selectLabel(index: number) { 
        if (this.state.labelIndex === index || this.isLoading) { 
            return;
        }
        this.setState({
            labelIndex: index,
        }, () => { 
                this.resetAction();
        });
    }

    // 重制页面数据
    private resetAction() { 
        this.isLoading = true;
        this.page = 1;
        this.setState({
            list: [],
            loadOver: false,
        }, () => { 
                this.getList();
        });
    }
}